import React from 'react';
// import PoError from '../loaders/poError';
import GenericCustomButton from '../../GenericCustomButton';
import IconsPath from '../../../assets/icons/index'
import Icons from '../../../assets/icons/index';
import LanguageTranslator from '../../../locals/LanguageTranslator';
export default class SaveFilterModal extends React.PureComponent {
    constructor(props){
        super(props);
        this.state = {
            filterName: "",
            filterType: "new",
            quickFilterItems: [],
            selectedFilter: "",
            alert: false,
            customHeadersType: this.props?.headersData?.item && this.props?.headersData?.item?.data && this.props?.headersData?.item["Custom Headers"] === undefined || this.props?.headersData?.item && this.props?.headersData?.item?.data && this.props?.headersData?.item["Custom Headers"]?.length === 0 ? "Default Headers" : "Custom Headers",
        }
    }

    getFilterValue = key => {
        switch(this.props.filterItems.columnType[key]) {
            case "NUMBER": 
            case "TIME": {
                return `From ${this.props.checkedFilters[key].from} to ${this.props.checkedFilters[key].to}`;
            }
            case "DATE": {
                if(!this.props.checkedFilters[key].key)
                    return `From ${this.props.checkedFilters[key].from} to ${this.props.checkedFilters[key].to}`;
                else if(this.props.checkedFilters[key].key === "SM_DATE_TODAY_VALUE")
                    return <LanguageTranslator>Today</LanguageTranslator>;
                else if(this.props.checkedFilters[key].key === "SM_DATE_YESTERDAY_VALUE")
                    return <LanguageTranslator>Yesterday</LanguageTranslator>;
                else if(this.props.checkedFilters[key].key === "SM_DATE_LAST7DAYS_VALUE")
                    return <LanguageTranslator>Last 7 Days</LanguageTranslator>;
                else if(this.props.checkedFilters[key].key === "SM_DATE_LASTWEEK_VALUE")
                    return <LanguageTranslator>Last Week</LanguageTranslator>;
                else if(this.props.checkedFilters[key].key === "SM_DATE_THISMONTH_VALUE")
                    return <LanguageTranslator>This Month</LanguageTranslator>;
                else if(this.props.checkedFilters[key].key === "SM_DATE_LASTMONTH_VALUE")
                    return <LanguageTranslator>Last Month</LanguageTranslator>;
                return "";
            }
            default: {
                if(this.props.checkedFilters[key] == "SM_TEXT_EMPTY_VALUE")
                    return "is Empty";
                else if(this.props.checkedFilters[key] == "SM_TEXT_NOT_EMPTY_VALUE")
                    return "is Not Empty";
                else
                    return this.props.checkedFilters[key];
            }
        }
    }

    getItemFilterValue = key => {
        switch(this.props.headersData.item.data.columnType[key]) {
            case "NUMBER": 
            case "TIME": {
                return `From ${this.props.checkedFilters.item[key].from} to ${this.props.checkedFilters.item[key].to}`;
            }
            case "DATE": {
                if(!this.props.checkedFilters.item[key].key)
                    return `From ${this.props.checkedFilters.item[key].from} to ${this.props.checkedFilters.item[key].to}`;
                else if(this.props.checkedFilters[key].key === "SM_DATE_TODAY_VALUE")
                    return <LanguageTranslator>Today</LanguageTranslator>;
                else if(this.props.checkedFilters[key].key === "SM_DATE_YESTERDAY_VALUE")
                    return <LanguageTranslator>Yesterday</LanguageTranslator>;
                else if(this.props.checkedFilters[key].key === "SM_DATE_LAST7DAYS_VALUE")
                    return <LanguageTranslator>Last 7 Days</LanguageTranslator>;
                else if(this.props.checkedFilters[key].key === "SM_DATE_LASTWEEK_VALUE")
                    return <LanguageTranslator>Last Week</LanguageTranslator>;
                else if(this.props.checkedFilters[key].key === "SM_DATE_THISMONTH_VALUE")
                    return <LanguageTranslator>This Month</LanguageTranslator>;
                else if(this.props.checkedFilters[key].key === "SM_DATE_LASTMONTH_VALUE")
                    return <LanguageTranslator>Last Month</LanguageTranslator>;
                return "";
            }
            default: {
                if(this.props.checkedFilters.item[key] == "SM_TEXT_EMPTY_VALUE")
                    return "is Empty";
                else if(this.props.checkedFilters.item[key] == "SM_TEXT_NOT_EMPTY_VALUE")
                    return "is Not Empty";
                else
                    return this.props.checkedFilters.item[key];
            }
        }
    }

    saveQuickFilter = () => {
        if(this.state.filterType === "new" && this.props.quickFilterItems.filter(item => item.filterName === this.state.filterName).length > 0) {
            this.setState({
                alert: true
            });
        }
        else {
            let filterName = this.state.filterType === "new" ? this.state.filterName : this.state.selectedFilter;
            this.props.saveQuickFilter(filterName, this.props.checkedFilters, false)();
        }
    }

    saveItemQuickFilter = () => {
        if(this.state.filterType === "new" && this.props.quickFilterItems.filter(item => item.filterName === this.state.filterName).length > 0) {
            this.setState({
                alert: true
            });
        }
        else {
            let filterName = this.state.filterType === "new" ? this.state.filterName : this.state.selectedFilter;
            this.props.saveQuickFilter(filterName, this.props.checkedFilters, false)();
        }
    }

    closeErrorModal = () => {
        this.setState({
            alert: false
        });
    }

    getExistingItemFilterValue = (key, filterValue) => {
        switch(this.props.headersData.item.data.columnType[key]) {
            case "NUMBER": 
            case "TIME": {
                return `From ${filterValue[key].from} to ${filterValue[key].to}`;
            }
            case "DATE": {
                if(!filterValue[key].key)
                    return `From ${filterValue[key].from} to ${filterValue[key].to}`;
                else if(this.props.checkedFilters[key].key === "SM_DATE_TODAY_VALUE")
                    return <LanguageTranslator>Today</LanguageTranslator>;
                else if(this.props.checkedFilters[key].key === "SM_DATE_YESTERDAY_VALUE")
                    return <LanguageTranslator>Yesterday</LanguageTranslator>;
                else if(this.props.checkedFilters[key].key === "SM_DATE_LAST7DAYS_VALUE")
                    return <LanguageTranslator>Last 7 Days</LanguageTranslator>;
                else if(this.props.checkedFilters[key].key === "SM_DATE_LASTWEEK_VALUE")
                    return <LanguageTranslator>Last Week</LanguageTranslator>;
                else if(this.props.checkedFilters[key].key === "SM_DATE_THISMONTH_VALUE")
                    return <LanguageTranslator>This Month</LanguageTranslator>;
                else if(this.props.checkedFilters[key].key === "SM_DATE_LASTMONTH_VALUE")
                    return <LanguageTranslator>Last Month</LanguageTranslator>;
                return "";
            }
            default: {
                if(filterValue[key] == "SM_TEXT_EMPTY_VALUE")
                    return "is Empty";
                else if(filterValue[key] == "SM_TEXT_NOT_EMPTY_VALUE")
                    return "is Not Empty";
                else
                    return filterValue[key];
            }
        }
    }

    getExistingFilterValue = (key, filterValue) => {
        switch(this.props.filterItems.columnType[key]) {
            case "NUMBER": 
            case "TIME": {
                return `From ${filterValue[key].from} to ${filterValue[key].to}`;
            }
            case "DATE": {
                if(!filterValue[key].key)
                    return `From ${filterValue[key].from} to ${filterValue[key].to}`;
                else if(this.props.checkedFilters[key].key === "SM_DATE_TODAY_VALUE")
                    return <LanguageTranslator>Today</LanguageTranslator>;
                else if(this.props.checkedFilters[key].key === "SM_DATE_YESTERDAY_VALUE")
                    return <LanguageTranslator>Yesterday</LanguageTranslator>;
                else if(this.props.checkedFilters[key].key === "SM_DATE_LAST7DAYS_VALUE")
                    return <LanguageTranslator>Last 7 Days</LanguageTranslator>;
                else if(this.props.checkedFilters[key].key === "SM_DATE_LASTWEEK_VALUE")
                    return <LanguageTranslator>Last Week</LanguageTranslator>;
                else if(this.props.checkedFilters[key].key === "SM_DATE_THISMONTH_VALUE")
                    return <LanguageTranslator>This Month</LanguageTranslator>;
                else if(this.props.checkedFilters[key].key === "SM_DATE_LASTMONTH_VALUE")
                    return <LanguageTranslator>Last Month</LanguageTranslator>;
                return "";
            }
            default: {
                if(filterValue[key] == "SM_TEXT_EMPTY_VALUE")
                    return "is Empty";
                else if(filterValue[key] == "SM_TEXT_NOT_EMPTY_VALUE")
                    return "is Not Empty";
                else
                    return filterValue[key];
            }
        }
    }

    closeModal = () => {
        document.getElementById("saveFilterModal")?.classList?.remove("from-bot-in")
        document.getElementById("saveFilterModal")?.classList?.add("from-bot-out")
        setTimeout(() => {
            this.props.closeSaveFilter();
        }, 100)
    }
    
    render () {
        return (
            <div className="modal">
                <div className="backdrop modal-backdrop-new" onClick={this.closeModal}></div>
                <div id='saveFilterModal' className="modal-content save-filter-modal !w-[650px] !h-[530px] !border-none !rounded-none !shadow-none from-bot-in">
                    <div className="sfm-head block pt-[20px] px-[40px] pb-0">
                        <div className="sfmh-top flex items-center justify-between">
                            <h3 className='text-base font-bold m-[0] text-[#12203c]'>Save Filter</h3>
                            <button className='border-2 border-black rounded-[50%] bg-white p-[4px] h-auto' type="button" onClick={this.closeModal}>
                                <IconsPath.ClearSearch />
                            </button>
                        </div>
                        <div className="sfmh-bottom block pt-[10px] px-0 pb-[15px] border-b border-[#c1d8f070]">
                            <p className='m-[0] text-xs font-medium text-[#97abbf]'>Create a new filter or replace an existing one</p>
                        </div>
                    </div>
                    <div className="sfm-body block py-[10px] px-[40px] overflow-auto max-h-[350px]">
                        <div className="sfmb-filter-row table w-full">
                            <div className="sfmbfr-filter block w-1/2 float-left pr-[15px]">
                                <label className="gen-radio-btn m-[0] text-[13px] text-xs font-medium text-[#12203c] pt-[0] pr-[0] pb-[5px] pl-[25px] !cursor-pointer relative whitespace-nowrap">
                                    <input type="radio" name="imageUploadType" value="Normal" checked={this.state.filterType == "new"} autocomplete="off" onClick={() => this.setState({filterType: "new", selectedFilter: ""})}/>
                                    <span class="checkmark"></span>
                                    Save as new filter
                                </label>
                                {this.state.filterType === "new" ? (
                                     <input className="width_235 onFocus" type="text" placeholder="Enter filter name" value={this.state.filterName} onChange={(e) => this.setState({ filterName: e.target.value })} /> ) 
                                     : ( this.props.quickFilterItems !== undefined && this.props.quickFilterItems.length !== 0 && ( <select className="sfmbfr-filter block w-1/2 float-left pr-[15px] width_235 onFocus" value={this.state.selectedFilter} onChange={(e) => this.setState({ selectedFilter: e.target.value })} > <option value="" > Select filter </option>
                                     {this.props.quickFilterItems.map((item, index) => (
                                         <option key={index} value={item.filterName}>
                                             {item.filterName}
                                         </option>
                                          ))}
                                     </select> ))}
                            </div>
                            <div className="sfmbfr-filter block w-1/2 float-left pr-[15px]">   
                                <label className="gen-radio-btn m-[0] text-[13px] text-xs font-medium text-[#12203c] pt-[0] pr-[0] pb-[5px] pl-[25px] !cursor-pointer relative whitespace-nowrap">
                                    <input type="radio" name="imageUploadType" value="Normal" checked={this.state.filterType == "existing"}  autocomplete="off" onClick={() => this.setState({filterType: "existing", filterName: ""})}/>
                                    <span class="checkmark"></span>
                                    Replace with existing filter
                                </label>
                                {/* {this.state.filterType === "new" ? 
                                <select className="sfmbfr-disabled" value="" disabled>
                                    <option value="" disabled>Select filter</option>
                                </select> :
                                <select className="sfmbfr-filter" value={this.state.selectedFilter} onChange={(e) => this.setState({selectedFilter: e.target.value})} >
                                    <option value="" disabled>Select filter</option>
                                    {this.props.quickFilterItems.map((item, index) => (
                                        <option value={item.filterName}>{item.filterName}</option>
                                    ))}
                                </select>} */}
                            </div>
                        </div>
                        <div className="sfmb-selected-filter block mt-[20px]">
                            <h3 className='text-sm font-semibold mb-2.5'>Selected Filters</h3>
                            <div className="sfmbsf-box border border-dashed border-[#c1d8f0] pt-[10px] px-3 pb-0 rounded-[7px]">
                                {Object.keys(this.props.checkedFilters).map((key) => {
                                    if(key === "item") {
                                        return Object.keys(this.props.checkedFilters.item).map(newKey=> (
                                            <div className="sfmbsfb-fil inline-block items-center py-[7px] px-[15px] bg-[#f2f5f8] rounded-[24px] mr-[13px] mb-2.5">
                                                <span className="sfmbsfb-name inline-block text-xs font-medium pr-[8px] text-[#5677b1]">{this.props.headersData.item.data[this.state.customHeadersType][newKey]}</span>
                                                <span className="sfmbsfb-num inline-block text-xs font-semibold text-[#5677b1] pl-[8px] border-l border-[#c1d8f0]">{this.getItemFilterValue(newKey)}</span>
                                            </div>
                                        ))
                                    }
                                    return <div className="sfmbsfb-fil inline-block items-center py-[7px] px-[15px] bg-[#f2f5f8] rounded-[24px] mr-[13px] mb-2.5">
                                        <span className="sfmbsfb-name inline-block text-xs font-medium pr-[8px] text-[#5677b1]">{this.props.filterItems[this.props.headerType][key]}</span>
                                        <span className="sfmbsfb-num inline-block text-xs font-semibold text-[#5677b1] pl-[8px] border-l border-[#c1d8f0]">{this.getFilterValue(key)}</span>
                                    </div>
                                })}
                            </div>
                        </div>
                        {this.state.filterType === "existing" && this.state.selectedFilter !== "" ?
                        <React.Fragment>
                            <div className="sfmb-existing-filter block mt-[20px]">
                                <h3 className='text-sm font-semibold mb-2.5'>Existing Filters</h3>
                                <div className="sfmbsf-box border border-dashed border-[#c1d8f0] pt-[10px] px-3 pb-0 rounded-[7px]">
                                    {this.props.quickFilterItems.map((item, index) =>
                                        item.filterName === this.state.selectedFilter ?
                                        Object.keys(item.filterValue).map((key) => {
                                            if(key === "item") {
                                                return Object.keys(item.filterValue.item).map(newKey=> (
                                                    <div className="sfmbsfb-fil inline-block items-center py-[7px] px-[15px] bg-[#fffae7] rounded-[24px] mr-[13px] mb-2.5">
                                                        <span className="sfmbsfb-name inline-block text-xs font-medium pr-[8px] text-[#d9ca8b]">{this.props.headersData.item.data[this.state.customHeadersType][newKey]}</span>
                                                        <span className="sfmbsfb-num inline-block text-xs font-semibold text-[#c19c01] pl-[8px] border-l border-[#d9ca8b]">{this.getExistingItemFilterValue(newKey, item.filterValue.item)}</span>
                                                    </div>
                                                ))
                                            }
                                            return <div className="sfmbsfb-fil inline-block items-center py-[7px] px-[15px] bg-[#fffae7] rounded-[24px] mr-[13px] mb-2.5">
                                                <span className="sfmbsfb-name inline-block text-xs font-medium pr-[8px] text-[#d9ca8b]">{this.props.filterItems[this.props.headerType][key]}</span>
                                                <span className="sfmbsfb-num inline-block text-xs font-semibold text-[#c19c01] pl-[8px] border-l border-[#d9ca8b]">{this.getExistingFilterValue(key, item.filterValue)}</span>
                                            </div>
                                        }) : null
                                    )}
                                </div>
                            </div>
                            <div className="sfmh-bottom flex items-center w-full m-top-15">
                                <Icons.SaveFilterWarning className='mr-2'/> <p className="warning m-[0] text-xs font-medium text-[#12203c]"> On Saving, existing filter values will be replaced with selected filter values </p>
                            </div>
                        </React.Fragment> :
                        null}
                    </div>
                    <div className="sfm-footer !flex !justify-center absolute bottom-[0] left-[0] w-full text-center pb-[22px] pt-[10px] bg-white">
                        <GenericCustomButton
                            type='primary'
                            size='large'
                            disabled={(this.state.filterType === "new" && this.state.filterName === "") || (this.state.filterType !== "new" && this.state.selectedFilter === "")} 
                            onClick={this.props.isItemRequire ? this.saveItemQuickFilter : this.saveQuickFilter}
                            loading={this.props.isLoading}
                            label="Save Filter"
                            className={'!h-[36px] min-w-[120px]'}
                        />
                    </div>
                </div>
                {/* {this.state.alert ? <PoError errorMassage={"A filter already exists with this name! Please enter a different name or select the existing filter to replace it."} closeErrorRequest={this.closeErrorModal} /> : null} */}
            </div>
        )
    }
}